import { throttle } from "lodash";
import { getOverflowX, getOffsetTop } from "./utils/layout";

declare const jQuery: any;
const $ = jQuery;
const $window = $(window);

type JQuery = any;

export function initCustomSelects(): void
{
	$("[data-custom-select]").each(function () {
		initCustomSelect(this);
	});
}

export function initCustomSelect($origSelect, insertAfterOriginalSelect = true): JQuery
{
	$origSelect = $($origSelect);
	if (!$origSelect[0] || $origSelect[0]._iw_select_inited)
	{
		return;
	}
	$origSelect[0]._iw_select_inited = true;
	
	const $customSelect = $(`<div class="custom-select"></div>`);
	const $customDisplay = $(`<div class="custom-select-display"></div>`);
	const $customOptionsWrap = $(`<div class="custom-select-options"></div>`);
	const optionSelectedClass = "custom-select-option-selected";
	const displayTextPrefix: string = $origSelect.attr("data-display-text-prefix") || "";
	const nullDisplayText: string = $origSelect.attr("data-null-display-text");
	const initialNullDisplayText: string = nullDisplayText ? undefined : $origSelect.attr("data-initial-null-display-text");
	const $overflowContainer = $origSelect.closest(`[data-custom-select-overflow-container]`);
	let $customOptions = $();
	
	if ($origSelect.is('[data-no-null]'))
	{
		$customSelect.addClass("custom-select-no-null");
	}

	function selectIsDisabled(): boolean
	{
		return $origSelect.is(`[disabled]`);
	}

	function close(): void
	{
		$customSelect.removeClass("open").trigger("closed");
		resetOptionsHorizontalPosition();
	}

	function open(): void
	{
		if (selectIsDisabled())
		{
			return;
		}
		$customSelect.removeClass("open-upwards").addClass("open");
		correctOptionsOpenDirection();
		correctOptionsHorizontalPosition();
		$customSelect.trigger("opened");
	}

	function toggle(): void
	{
		if (selectIsDisabled())
		{
			return;
		}
		$customSelect.removeClass("open-upwards").toggleClass("open");
		resetOptionsHorizontalPosition();
		if ($customSelect.hasClass("open"))
		{
			correctOptionsOpenDirection();
			correctOptionsHorizontalPosition();
			$customSelect.trigger("opened");
		}
		else
		{
			$customSelect.trigger("closed");
		}
	}

	function closeOthers(): void
	{
		$(".custom-select.open").not($customSelect).removeClass("open");
	}

	function selectOption($origOption, $customOption, suppressChange = false): void
	{
		const value: string = $origOption.val();
		$origSelect.val(value);
		$customOptions.removeClass(optionSelectedClass);
		$customOption.addClass(optionSelectedClass);
		let displayHtml: string;
		if (value)
		{
			displayHtml = displayTextPrefix + ($customOption.attr("data-display-text") || $customOption.html());
		}
		else
		{
			displayHtml = nullDisplayText || $customOption.attr("data-display-text") || $customOption.html();
		}
		$customDisplay.html(displayHtml);
		close();
		if (!suppressChange)
		{
			$origSelect.trigger("change");
		}
	}

	function setOptionsDisabled(): void
	{
		const $customOptions = $customSelect.find("[data-option-value]").removeAttr("data-option-disabled");
		$origSelect.find("option[disabled]").each(function () {
			const $origOption = $(this);
			const value: string = $origOption.val();
			const $customOption = $customOptions.filter(function () {
				return $(this).attr("data-option-value") === value;
			});
			$customOption.attr("data-option-disabled", "");
		});
	}

	// For updating custom select from original select when original select
	// is changed programmatically
	$origSelect.on("changed", e => {
		const value = $origSelect.val();
		setOptionsDisabled();
		const $origOption = $origSelect.find("option").filter(function () {
			return $(this).val() === value;
		}).first();
		if ($origOption.is("[disabled]"))
		{
			return;
		}
		const $customOption = $customSelect.find("[data-option-value]").filter(function () {
			return $(this).attr("data-option-value") === value;
		}).first();
		selectOption($origOption, $customOption, true);
	});

	$customSelect.
		append($customDisplay).
		append($customOptionsWrap).
		on("click", ev => {
			ev.stopPropagation();
			closeOthers();
		});

	if (insertAfterOriginalSelect)
	{
		$customSelect.insertAfter($origSelect);
	}
	
	function buildOptions(): void
	{
		const $origOptions = $origSelect.find("option");
		const defaultSelectValue = $origSelect.val();
		let defaultOptionSelected = false;
		$origOptions.each(function (index: number) {
			const $origOption = $(this);
			const $customOption = $(`<div class="custom-select-option">${$origOption.html()}</div>`);
			$customOption.attr("data-option-value", $origOption.val() || "").
				attr("data-display-text", $origOption.attr("data-display-text") || "");
			if ($origOption.is("[data-option-class]"))
			{
				$customOption.addClass($origOption.attr("data-option-class"));
			}
			if ($origOption.is("[data-option-title]"))
			{
				$customOption.attr("title", $origOption.attr("data-option-title"));
			}
			const select = () => selectOption($origOption, $customOption);
			$customOption.on("click", select).appendTo($customOptionsWrap);
			$customOptions = $customOptions.add($customOption);
			if ($origOption.val() === defaultSelectValue && !defaultOptionSelected)
			{
				select();
				defaultOptionSelected = true;
			}
			$origOption.on("customSelectOptionChange", function (event) {
				select();
				event.stopPropagation();
			});
		});
		if (!defaultOptionSelected)
		{
			selectOption($origOptions.first(), $customOptions.first(), true);
		}
	}

	function correctOptionsOpenDirection(): void
	{
		const optionsHeight: number = $customOptionsWrap.outerHeight();
		if (!optionsHeight) return;
		const optionsTop: number = getOffsetTop($customOptionsWrap);
		const optionsBottom: number = optionsTop + optionsHeight;
		const windowScrollTop: number = $window.scrollTop();
		const windowScrolled: number = $window.outerHeight() + windowScrollTop;
		const dy: number = optionsBottom - windowScrolled;
		if (dy <= 0)
		{
			return;
		}
		const optionsTopIfFixed: number = (optionsTop - $customDisplay.outerHeight()) - optionsHeight;
		if (optionsTopIfFixed < windowScrollTop)
		{
			return;
		}
		const $bodyWrapper = $(document.getElementById("body-wrapper"));
		const bodyWrapperTop: number = $bodyWrapper.offset().top || 0;
		if ((bodyWrapperTop > 0) && (optionsTopIfFixed < (windowScrollTop + bodyWrapperTop)))
		{
			return;
		}
		$customSelect.addClass("open-upwards");
	}

	function correctOptionsHorizontalPosition(): void
	{
		const overflowX: number = getOverflowX($customOptionsWrap, $overflowContainer);
		if (overflowX > 0)
		{
			$customOptionsWrap.css({ transform: `translateX(-${overflowX}px)` });
		}
	}

	function resetOptionsHorizontalPosition(): void
	{
		$customOptionsWrap.css({ transform: "" });
	}

	function setSelectDisabled(): void
	{
		if ($origSelect.is(`[disabled]`))
		{
			$customSelect.attr("data-disabled", "");
		}
		else
		{
			$customSelect.removeAttr("data-disabled");
		}
	}
	
	setSelectDisabled();
	buildOptions();
	$customSelect.on("close", close).on("open", open);
	$customDisplay.on("click", toggle);
	$("body").on("click", close);

	if (!$origSelect.val() && (nullDisplayText || initialNullDisplayText))
	{
		$customDisplay.html(nullDisplayText || initialNullDisplayText);
	}
	
	$origSelect.closest("form").on("reset", function () {
		setTimeout(() => $origSelect.trigger("customSelectChange"), 80);
	});

	$origSelect.on("customSelectChange", function (event) {
		event.stopPropagation();
		const value = $origSelect.val();
		if (value === undefined)
		{
			return;
		}
		$origSelect.find("option").filter(function () {
			return value === this.value;
		}).trigger("customSelectOptionChange");
	});
	
	$origSelect.on("options-changed", function () {
		close();
		$customOptions = $();
		$customOptionsWrap.empty();
		buildOptions();
	}).on("disabled-changed", function () {
		setSelectDisabled();
	});

	if ($origSelect.is(`[data-dynamic-width]`))
	{
		setupWidthCorrection($customSelect, parseInt($origSelect.attr("data-dynamic-width-offset"), 10));
	}

	return $customSelect;
}

function setupWidthCorrection($customSelect, widthOffset: number): void
{
	function correct(): void
	{
		const isOpen: boolean = $customSelect.hasClass("open");
		const $options = $customSelect.find(`.custom-select-option`);
		const cachedOptionCss = {
			display: $options.css("display")
		};
		let maxWidth: number = 0;
		$customSelect.css({ width: "100%" }).addClass("open");
		$options.each(function () {
			const width: number = $(this).css({ display: "inline-block" }).outerWidth();
			if (width && width > maxWidth)
			{
				maxWidth = width;
			}
		});
		$options.css(cachedOptionCss);
		$customSelect.css({ width: maxWidth + (widthOffset || 0) });
		if (!isOpen)
		{
			$customSelect.removeClass("open");
		}
	}
	correct();
	$window.on("load resize", throttle(correct, 100));
}

function initCF7CustomSelects(): void
{
	$(".wpcf7 select").each(function () {
		initCustomSelect(this);
	});
}

if (!window["iw"])
{
	window["iw"] = {};
}

window["iw"].initCustomSelects = initCustomSelects;
window["iw"].initCustomSelect = initCustomSelect;
window["iw"].initCF7CustomSelects = initCF7CustomSelects;
